import { Link, useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../contexts/AuthContext.tsx";
import { useCart } from "../contexts/CartContext.tsx";
import logo from "../logo.svg";
import logo_blue from "../logo_blue.svg";

const categories = [
  { name: "Kampanyalar", path: "/campaigns" },
  { name: "Markalar", path: "/brands" },
  { name: "İndirimler", path: "/discounts" },
  { name: "Çok Satanlar", path: "/popular" },
];

const Navbar = () => {
  const { isAuthenticated, logout, user } = useAuth();
  const { cart } = useCart();
  const navigate = useNavigate();
  const location = useLocation();
  const [search, setSearch] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  const isAdminPanel = location.pathname.startsWith("/admin");

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(`/search?search=${encodeURIComponent(search)}`);
    setMenuOpen(false);
  };
  return (
    <header className={`${isAdminPanel ? "bg-sky-900 text-white" : "bg-white text-blue-700"} shadow sticky top-0 z-50`}>
      <div className="max-w-full mx-auto flex flex-col gap-0">
        {/* Üst bar */}
        <div className="flex items-center justify-between py-2 px-2 md:px-4">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 min-w-[120px]">
            <img src={isAdminPanel ? logo : logo_blue} alt="Logo" className="h-10 w-10" />
            <span className={`font-bold text-xl ${isAdminPanel ? "text-white" : "text-blue-700"}`}>Lotus Tedarik</span>
          </Link>

          {/* Arama kutusu - sadece admin paneli dışında göster */}
          {!isAdminPanel && (
            <form onSubmit={handleSearch} className="hidden md:flex flex-1 mx-4 max-w-xl">
              <div className="relative w-full">
                <input
                  type="text"
                  className="w-full border rounded-full py-2 px-4 pl-10 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Ürün, kategori veya marka ara..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <svg className="absolute left-3 top-2.5 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <circle cx="11" cy="11" r="8" strokeWidth="2" />
                  <path strokeWidth="2" d="M21 21l-4.35-4.35" />
                </svg>
              </div>
            </form>
          )}

          {/* Sağ Menü - md ve üstü */}
          <div className="hidden md:flex items-center gap-4 min-w-[220px] justify-end">
            <Link to="/cart" className="relative font-medium hover:text-blue-600">
              <svg className="w-6 h-6 inline-block mr-1 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeWidth="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4" />
                <circle cx="9" cy="21" r="1" />
                <circle cx="20" cy="21" r="1" />
              </svg>
              Sepet
              <span className="ml-1 bg-blue-600 text-white rounded-full px-2 py-0.5 text-xs">
                {cart?.length ?? 0}
              </span>
            </Link>
            {isAuthenticated ? (
              <>
                <Link to="/orders" className="hover:text-blue-600 font-medium">Siparişlerim</Link>
                {user?.role === "Admin" && (
                  <Link to="/admin/dashboard" className="hover:text-blue-600 font-medium">
                    Admin Panel
                  </Link>
                )}
                <Link to="/profile" className="hover:text-blue-600 text-sm">
                  {user?.username}
                </Link>
                <button
                  onClick={() => { logout(); navigate("/login"); }}
                  className="ml-2 bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                >
                  Çıkış Yap
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={() => navigate("/login")}
                  className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                >
                  Giriş Yap
                </button>
                <button
                  onClick={() => navigate("/register")}
                  className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600 ml-2"
                >
                  Kayıt Ol
                </button>
              </>
            )}
          </div>

          {/* Mobil Menü Butonu */}
          <button
            className={`md:hidden ${isAdminPanel ? "text-white" : "text-blue-700"} focus:outline-none ml-2`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menüyü Aç/Kapat"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              {menuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobil menü içeriği (hamburger açıldığında) */}
        {menuOpen && (
          <div className="md:hidden flex flex-col gap-3 px-2 pb-3 bg-white border-b border-gray-100">
            {!isAdminPanel && (
              <form onSubmit={handleSearch}>
                <div className="relative">
                  <input
                    type="text"
                    className="w-full border rounded-full py-2 px-4 pl-10 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Ürün, kategori veya marka ara..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <svg className="absolute left-3 top-2.5 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <circle cx="11" cy="11" r="8" strokeWidth="2" />
                    <path strokeWidth="2" d="M21 21l-4.35-4.35" />
                  </svg>
                </div>
              </form>
            )}
            <div className="flex flex-col gap-2 text-blue-800 font-medium">
              <Link to="/cart" onClick={() => setMenuOpen(false)}>
                Sepet ({cart?.length ?? 0})
              </Link>
              {isAuthenticated ? (
                <>
                  <Link to="/orders" onClick={() => setMenuOpen(false)}>Siparişlerim</Link>
                  {user?.role === "Admin" && (
                    <Link to="/admin/dashboard" onClick={() => setMenuOpen(false)}>Admin Panel</Link>
                  )}
                  <Link to="/profile" onClick={() => setMenuOpen(false)}>
                    {user?.username}
                  </Link>
                  <button
                    onClick={() => { logout(); navigate("/login"); setMenuOpen(false); }}
                    className="text-red-500 font-semibold"
                  >
                    Çıkış Yap
                  </button>
                </>
              ) : (
                <>
                  <button onClick={() => { navigate("/login"); setMenuOpen(false); }}>Giriş Yap</button>
                  <button onClick={() => { navigate("/register"); setMenuOpen(false); }}>Kayıt Ol</button>
                </>
              )}
            </div>
          </div>
        )}

        {/* Alt bar: Kategori menüsü - sticky ve yatay scroll */}
        {!isAdminPanel && (
          <nav className="sticky top-[64px] bg-sky-900 text-white w-full overflow-x-auto whitespace-nowrap border-t border-sky-800 z-40">
            <div className="flex gap-2 px-2 py-2 min-w-full justify-start">
              {categories.map((cat) => (
                <Link
                  key={cat.name}
                  to={cat.path}
                  className="hover:text-sky-300 px-3 py-1 rounded transition-colors duration-200"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Navbar;